/** How long a list's name may be: the upstream ListSaveRequest limit. */
export const LIST_NAME_MAX = 120;

/**
 * The reserved dress that marks a Chat Day's list (AI-2744): the Lists panel's
 * Chat Day chip filters on the icon, so every producer must use exactly this.
 */
export const CHAT_DAY_LIST_DRESS = { icon: 'chat-day', color: 'violet' } as const;

/** A name cut to fit, dropping a half-cut surrogate pair rather than sending a lone one. */
export function listNameFrom(name: string): string {
  return name.slice(0, LIST_NAME_MAX).replace(/[\uD800-\uDBFF]$/, '');
}
